import { AnswerModel } from 'core/models/elements/answers/answer.abstract.model';

import { pascalToCamel } from 'utils/common.util';

/**
 * @class Defines an answer corresponding to a paper question.
 * The scan file is not provided by the player.
 */
export class PaperQuestionAnswerModel extends AnswerModel {
  /**
   * @constructor Creates an instance of a paper answer built from an original data from the API.
   * @param {bo} bo is the basic object come from API.
   */
  constructor(bo) {
    super(bo);
    this.scanFileUrl = bo.scan_file_url ?? bo.scanFileUrl ?? null;
  }

  static instantiateFromApi(data) {
    const bo = pascalToCamel(data);
    return new PaperQuestionAnswerModel(bo);
  }
}
